import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { AppTopbarComponent } from "./app.topbar";

@Component({
  selector: "app-no-menu-layout",
  standalone: true,
  imports: [CommonModule, RouterModule, AppTopbarComponent],
  template: `
    <header class="max-w-[1000px] mx-auto px-4 pt-6">
      <div app-topbar></div>
    </header>
    <main class="max-w-[1000px] mx-auto px-4 pb-6">
      <router-outlet></router-outlet>
    </main>
  `,
})
export class AppNoMenuLayoutComponent {
  constructor(public router: Router) {}
}
